import React from "react";
import "../styles/Guidelines.css";

const Guidelines = () => {
  return (
    <article className="guideline-cont">
        <div className="guidelines-container">
      <h1 className="title">Problem Statements</h1>

      <div className="guideline-downloads">
        <a
          href="/assets/Problem_Statement_AI.pdf"
          download="Innovastra-Problem_Statement_AI"
          className="download-btn"
        >
          AI/ML
        </a>
      </div>

      <div className="rules-and-regulation">
        <a
          href="/assets/Problem_Statements_web3.pdf"
          download="Innovastra-Problem_Statements_web3"
          className="download-btn"
        >
          Web3
        </a>
        <a
          href="/assets/Problem_Statement_Common_To_all.pdf"
          download="Innovastra-Problem_Statement_Common_To_all"
          className="download-btn"
        >
          Common to all
        </a>
        <a
          href="/assets/Problem_Statement_AgriTech.pdf"
          download="Innovastra-Problem_Statement_AgriTech"
          className="download-btn"
        >
          AgriTech
        </a>
        <a
          href="/assets/Problem_Statement_HealthCare.pdf"
          download="Innovastra-Problem_Statement_HelthCare"
          className="download-btn"
        >
          HelthCare
        </a>
        <a
          href="/assets/Problem_Statement_Blockchain.pdf"
          download="Innovastra-Problem_Statement_Blockchain"
          className="download-btn"
        >
          Blockchain
        </a>
        <a
          href="/assets/Problem_Statement_FinTech.pdf"
          download="Innovastra-Problem_Statement_FinTech"
          className="download-btn"
        >
          FinTech
        </a>
        <a
          href="/assets/Problem_Statement_CyberSecurity.pdf"
          download="Innovastra-Problem_Statement_CyberSecurity"
          className="download-btn"
        >
          Cyber Security
        </a>
      </div>

      <section className="final-words">
        <p>Good luck and have fun during the hackathon!</p>
        <p>Best Regards,<br></br>Team Innovastra</p>
      </section>
    </div>
    </article>
  );
};

export default Guidelines;
